/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-07-19 10:31:23
 * @LastEditTime: 2019-09-10 19:51:38
 * @LastEditors: Please set LastEditors
 */
import CryptoJS from 'crypto-js/crypto-js'

const KEY = CryptoJS.enc.Utf8.parse(2015020120200131)

const encode = {
  encodeFunc: function (obj) {
    // obj = JSON.stringify(obj)
    console.log(obj)
    let eObj = null
    if (typeof obj == 'string' ) {
      eObj = obj
    } else {
      eObj = JSON.stringify(obj)
    }
    let key = KEY
    let enCodeAes = CryptoJS.AES.encrypt(eObj, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }).toString()
    // let enCodeMd5 = Md5(JSON.stringify(obj))
    let enCodeMd5 = CryptoJS.MD5(eObj).toString()
    let sendData = {
      data: enCodeAes,
      md5: enCodeMd5
    }
    // console.log(sendData);
    return sendData
  },
  decodeFuc: function (obj) {
    // console.log(obj);
    let key = KEY
    // obj = CryptoJS.enc.Base64.stringify(obj);
    let decodeAes = CryptoJS.AES.decrypt(obj, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }).toString(CryptoJS.enc.Utf8)
    return decodeAes
  },
  encodeStr: function (str) {
    // obj = JSON.stringify(obj)
    console.log(str)
    let key = KEY

    let enCodeAes = CryptoJS.AES.encrypt(str, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }).toString()
    console.log(enCodeAes);
    return enCodeAes
  },

}
export default encode



// WEBPACK FOOTER //
// ./src/server/api/encode.js